import React, { useState, useEffect, useRef, useLayoutEffect} from 'react';
import _ from 'underscore';

// MUI imports
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  TableCell,
  Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export const DynamicRotatedCell = ({ value, highlightedSample, clickSample }) => {
    const [height, setHeight] = useState(50); // Default minimum height
    const textRef = useRef(null);
  
    useLayoutEffect(() => {
      if (textRef.current) {
        // Measure how wide the text is
        const textWidth = textRef.current.scrollWidth;
        // Convert degrees to radians for the angle
        const angleRadians = 80 * (Math.PI / 180);
        // Estimate how tall the cell needs to be when rotated
        const calculatedHeight = Math.ceil(textWidth * Math.sin(angleRadians)) + 10; 
        // Never go below 50px
        setHeight(Math.max(calculatedHeight, 50));
      }
    }, [value]);
  
    return (
      <td
        className="bg-gray-300 w-[50px] overflow-visible relative"
        title={value}
        style={{ height: `${height}px` }}
      >
        <div
          ref={textRef}
          className="cursor-pointer absolute bottom-0 left-0 origin-left-bottom"
          style={{
            transform: 'rotate(-80deg)',
            transformOrigin: 'left bottom',
            whiteSpace: 'nowrap',
            color: value === highlightedSample ? 'blue' : 'black',
          }}
          id={value}
          onClick={() => clickSample(value)}
        >
          {value}
        </div>
      </td>
    );
  };

const HaploviewerModal = (props) => {
    let {
        haploData,
        setHaploData,
        haploModalIsOpen,
        setHaploModalIsOpen,
        setAccessVariantIsOpen,
        setLoading,
    } = props;

    const imgSrc = require("../img/command.jpg");
    const style = { marginRight: "10px" };

    const [shouldUpdate, setShouldUpdate] = useState(false);
    const [clickedSample, setClickedSample] = useState(null);
    const [highlightedSample, setHighlightedSample] = useState(null);
    const [showTips, setShowTips] = useState(false);
    const [showLegend, setShowLegend] = useState(false);

    const modalRef = useRef(null);

    useEffect(() => {
        if (haploModalIsOpen && modalRef.current) {
            modalRef.current.focus();
        }
        function handleKeyDown(event) {
            if (event.key === 'Escape' && haploModalIsOpen) {
                setHaploModalIsOpen(false);
            }
        }
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [haploModalIsOpen, setHaploModalIsOpen]);

    const handleClose = () => {
        setHaploModalIsOpen(false);
    };

    const handleGoBack = () => {
        setHaploModalIsOpen(false);
        setAccessVariantIsOpen(true);
    };

    const clearSamplesInput = () => {
        setHighlightedSample(null);
        const updatedCombo = haploData.combo.map(item => ({
            ...item,
            input: ''
        }));

        setHaploData(prevData => ({
            ...prevData,
            combo: updatedCombo
        }));
    };

    const removeHaploVariant = (sample) => {
        const indexToRemove = haploData.x.findIndex(value => value === sample);
        if (indexToRemove === -1) return;

        const newX = haploData.x.filter((_, idx) => idx !== indexToRemove);
        const newCombo = haploData.combo.map(row => ({
            ...row,
            text: row.text.filter((_, idx) => idx !== indexToRemove),
            z: row.z.filter((_, idx) => idx !== indexToRemove),
        }));
        const newText = haploData.text.map(row => row.filter((_, idx) => idx !== indexToRemove));
        const newZ = haploData.z.map(row => row.filter((_, idx) => idx !== indexToRemove));

        setHaploData(prevData => ({
            ...prevData,
            x: newX,
            combo: newCombo,
            text: newText,
            z: newZ
        }));

        setTimeout(() => {
            console.log("after haploData: ", haploData);
        }, 500);
    };

    // const sortSamplesInput = () => {
    //     setHighlightedSample(null);
    //     console.log("sort.. ");

    //     const combo = haploData.combo.slice();
    //     var inputs = [];
    //     _.each(combo, function (value) {
    //         if (value.input === '') {
    //             inputs.push(undefined);
    //         } else {
    //             inputs.push(value.input);
    //         }
    //     });
    //     console.log("inputs: ", inputs);

    //     var sortedInputs = sortWithIndeces(inputs);
    //     var sortedIndices = sortedInputs.sortIndices;

    //     var ySorted = reorderByIndexes(haploData.y, sortedIndices);
    //     var t = haploData.text[0].map((col, i) => haploData.text.map(row => row[i]));
    //     var sortedTransposed = [];
    //     _.each(t, function (value) {
    //         var dat = reorderByIndexes(value, sortedIndices);
    //         sortedTransposed.push(dat);
    //     });
    //     var newTextArray = sortedTransposed[0].map((col, i) => sortedTransposed.map(row => row[i]));

    //     var zt = haploData.z[0].map((col, i) => haploData.z.map(row => row[i]));
    //     var sortedZTransposed = [];
    //     _.each(zt, function (value) {
    //         var dat = reorderByIndexes(value, sortedIndices);
    //         sortedZTransposed.push(dat);
    //     });
    //     var newZArray = sortedZTransposed[0].map((col, i) => sortedZTransposed.map(row => row[i]));

    //     var result = [];
    //     _.each(newZArray, function (value, key) {
    //         var s = value.toString();
    //         s = s.split('.').join("");
    //         s = s.split(",");
    //         var obj = {
    //             z: s,
    //             text: newTextArray[key],
    //             input: inputs[key]
    //         };
    //         result.push(obj);
    //     });

    //     const updatedDataArray = result.map(item => ({
    //         ...item,
    //         input: item.input === undefined ? '' : item.input
    //     }));
    //     console.log("updated: ", updatedDataArray );

    //     setTimeout(() => {
    //         setHaploData(prevData => ({
    //             ...prevData,
    //             y: ySorted,
    //             z: newZArray,
    //             combo: updatedDataArray,
    //             text: newTextArray
    //         }));
    //         setShouldUpdate(false);
    //         setLoading(false);
    //     }, 500);
    // };

    const sortSamplesInput = () => {
        setHighlightedSample(null);
      
        // Create a local helper that sorts numerically where possible, and
        // pushes empty/undefined values to the bottom:
        function sortWithIndecesEnhanced(arr) {
          const mapped = arr.map((val, idx) => ({ val, idx }));
      
          mapped.sort((a, b) => {
            // Both empty
            if ((!a.val || a.val.trim() === '') && (!b.val || b.val.trim() === '')) return 0;
            // a is empty, push it down
            if (!a.val || a.val.trim() === '') return 1;
            // b is empty, push it down
            if (!b.val || b.val.trim() === '') return -1;
      
            // Try numeric comparison
            const aNum = parseFloat(a.val);
            const bNum = parseFloat(b.val);
            const aIsNum = !isNaN(aNum);
            const bIsNum = !isNaN(bNum);
      
            // If both numeric, sort numerically
            if (aIsNum && bIsNum) return aNum - bNum;
            // Otherwise fall back to string comparison
            return a.val.localeCompare(b.val);
          });
      
          // Extract sorted values and their original indices
          const sorted = mapped.map(item => item.val);
          sorted.sortIndices = mapped.map(item => item.idx);
      
          return sorted;
        }
      
        // Make a shallow copy of combo
        const combo = haploData.combo.slice();
      
        // Gather input values
        const inputs = combo.map(row => row.input);
      
        // Use the enhanced sort to get new sorted order
        const sortedInputs = sortWithIndecesEnhanced(inputs);
        const sortedIndices = sortedInputs.sortIndices;
      
        // Reorder y
        const ySorted = reorderByIndexes(haploData.y, sortedIndices);
      
        // Reorder text by transposing -> sorting -> untransposing
        const transposedText = haploData.text[0].map((_, i) => haploData.text.map(row => row[i]));
        const sortedTransposedText = transposedText.map(column => reorderByIndexes(column, sortedIndices));
        const newTextArray = sortedTransposedText[0].map((_, i) => sortedTransposedText.map(row => row[i]));
      
        // Same approach for z
        const transposedZ = haploData.z[0].map((_, i) => haploData.z.map(row => row[i]));
        const sortedTransposedZ = transposedZ.map(column => reorderByIndexes(column, sortedIndices));
        const newZArray = sortedTransposedZ[0].map((_, i) => sortedTransposedZ.map(row => row[i]));
      
        // Build new combo rows
        const updatedDataArray = newZArray.map((zVals, idx) => {
          // Convert each array of z-values into a string array
          const zClean = zVals.toString().replaceAll('.', '').split(',');
          return {
            z: zClean,
            text: newTextArray[idx],
            input: sortedInputs[idx] || ''
          };
        });

        console.log("update: ", updatedDataArray );
      
        setTimeout(() => {
          setHaploData(prev => ({
            ...prev,
            y: ySorted,
            z: newZArray,
            combo: updatedDataArray,
            text: newTextArray
          }));
          setShouldUpdate(false);
          setLoading(false);
        }, 500);
      };
      
      

    const clickSample = (sample) => {
        setHighlightedSample(sample);
        setLoading(true);
        setClickedSample(sample);
        setShouldUpdate(prev => !prev);
    };

    const handleInputChange = (value, comboIndex) => {
        let updatedHaploData = { ...haploData };
        updatedHaploData.combo[comboIndex].input = value;
        setHaploData(updatedHaploData);
    };

    useEffect(() => {
        if (shouldUpdate) {
            var index;
            _.each(haploData.x, function (value, key) {
                if (value === clickedSample) {
                    index = key;
                }
            });
            var col = [];
            _.each(haploData.text, function (value) {
                col.push(value[index]);
            });
            var sortedArray = sortWithIndeces(col);
            var sortedIndices = sortedArray.sortIndices;

            var ySorted = reorderByIndexes(haploData.y, sortedIndices);
            var t = haploData.text[0].map((col, i) => haploData.text.map(row => row[i]));
            var sortedTransposed = [];
            _.each(t, function (value) {
                var dat = reorderByIndexes(value, sortedIndices);
                sortedTransposed.push(dat);
            });
            var newTextArray = sortedTransposed[0].map((col, i) => sortedTransposed.map(row => row[i]));

            var zt = haploData.z[0].map((col, i) => haploData.z.map(row => row[i]));
            var sortedZTransposed = [];
            _.each(zt, function (value) {
                var dat = reorderByIndexes(value, sortedArray.sortIndices);
                sortedZTransposed.push(dat);
            });
            var newZArray = sortedZTransposed[0].map((col, i) => sortedZTransposed.map(row => row[i]));

            var result = [];
            _.each(newZArray, function (value, key) {
                var s = value.toString();
                s = s.split('.').join("");
                s = s.split(",");
                var obj = {
                    z: s,
                    text: newTextArray[key]
                };
                result.push(obj);
            });

            console.log("combo: ", result);
            console.log("text: ", newTextArray);

            setTimeout(() => {
                setHaploData({
                    ...haploData,
                    y: ySorted,
                    z: newZArray,
                    combo: result,
                    text: newTextArray
                });
                setShouldUpdate(false);
                setLoading(false);
            }, 500);
        }
    }, [shouldUpdate, haploData, clickedSample, setHaploData, setLoading]);

    return (
        <Dialog
            open={haploModalIsOpen}
            onClose={handleClose}
            PaperProps={{
                style: {
                    maxHeight: '95%',
                    maxWidth: '95%',
                    overflowY: 'auto',
                    boxShadow: '0 3px 10px rgba(0,0,0,0.5)'
                }
            }}
            fullWidth
            maxWidth="xl"
        >
            {haploModalIsOpen && (
                <Box ref={modalRef} tabIndex="0" sx={{ outline: 'none' }}>
                    <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span>Haploviewer</span>
                        <IconButton onClick={handleClose} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent dividers>
                        {/* Loader */}
                        <div className="flex justify-center items-center" id="haplo-loader-spinner" style={{ display: 'none' }}></div>

                        {/* HaploViewer Table */}
                        <div className="row" style={{ margin: '5px' }}>
                            <div style={{ overflow: 'auto' }} id="scrollable-area">
                                <table className="table" id="haplo-table">
                                    <tbody>
                                        {haploData.combo && haploData.combo.map((x, index) => (
                                            <tr key={index}>
                                                {/* <td className="text-center bg-gray-300 p-2 sticky top-0 z-10 w-[100px]" style={{maxWidth:"100px"}}>
                                                    {haploData.y[index]}
                                                </td> */}
                                                <TableCell
                                                    align="center"
                                                    sx={{
                                                        width: 100,
                                                        maxWidth: 100,
                                                        bgcolor: 'grey.300',
                                                        position: 'sticky',
                                                        top: 0,
                                                        zIndex: 10,
                                                        overflow: 'hidden',
                                                        whiteSpace: 'nowrap',
                                                        textOverflow: 'ellipsis'
                                                    }}
                                                >
                                                    {haploData.y[index]}
                                                </TableCell>

                                                <td className="text-center bg-gray-300 p-2 sticky top-0 z-10 w-[50px]" style={{maxWidth: "50px"}}>
                                                    <input
                                                        placeholder="..."
                                                        type="text"
                                                        className="text-center border rounded w-full"
                                                        value={x.input}
                                                        onChange={e => { handleInputChange(e.target.value, index); }}
                                                    />
                                                </td>
                                                {x.text.map((y, yIndex) => (
                                                    <td
                                                        key={yIndex}
                                                        className={`text-center border border-gray-300 p-2 w-[50px] ${y} color${x.z[yIndex]}`}
                                                        title={haploData.y[index]}
                                                    >
                                                        {y}
                                                    </td>
                                                ))}
                                            </tr>
                                        ))}

                                        {/* Remove Variant Row */}
                                        <tr className="sample-row">
                                            <td className="bg-gray-300">
                                                <div className="text-center sticky top-0 z-10">Remove Variant</div>
                                            </td>
                                            <td className="bg-gray-300">
                                                <div className="text-center">
                                                    <Button
                                                        variant="contained"
                                                        color="error"
                                                        onClick={clearSamplesInput}
                                                    >
                                                        Clear
                                                    </Button>
                                                </div>
                                            </td>
                                            {haploData.x && haploData.x.map((value, key) => (
                                                <td key={key} className="bg-gray-300">
                                                    <div className="text-center text-red-500 cursor-pointer">
                                                        <i
                                                            className="far fa-times-circle text-xl"
                                                            onClick={() => removeHaploVariant(value)}
                                                        ></i>
                                                    </div>
                                                </td>
                                            ))}
                                        </tr>

                                        {/* Click to Sort Row */}
                                        {/* <tr className="sample-row">
                                            <td className="bg-gray-300">
                                                <div className="text-center sticky top-0 z-10">Click to Sort</div>
                                            </td>
                                            <td className="bg-gray-300">
                                                <div className="text-center">
                                                    <Button
                                                        variant="contained"
                                                        color="inherit"
                                                        onClick={sortSamplesInput}
                                                    >
                                                        Sort
                                                    </Button>
                                                </div>
                                            </td>
                                           
                                            {haploData.x && haploData.x.map((value, key) => (
                                                <td
                                                    key={key}
                                                    className="bg-gray-300 w-[50px] h-[150px] overflow-visible relative"
                                                    title={value}
                                                >
                                                    <div
                                                        className="cursor-pointer absolute bottom-0 left-0 origin-left-bottom"
                                                        style={{
                                                            transform: 'rotate(-45deg)',
                                                            transformOrigin: 'left bottom',
                                                            width: 'calc(100% * 1.4142)', // Account for diagonal rotation
                                                            whiteSpace: 'nowrap',
                                                            color: value === highlightedSample ? 'blue' : 'black'
                                                        }}
                                                        id={value}
                                                        onClick={() => clickSample(value)}
                                                    >
                                                        {value}
                                                    </div>
                                                </td>
                                            ))}

                                        </tr> */}

                                        {/* Click to Sort Row */}
                                        <tr className="sample-row">
                                            <td className="bg-gray-300">
                                                <div className="text-center sticky top-0 z-10">Click to Sort</div>
                                            </td>
                                            <td className="bg-gray-300">
                                                <div className="text-center">
                                                    <Button
                                                        variant="contained"
                                                        color="inherit"
                                                        onClick={sortSamplesInput}
                                                    >
                                                        Sort
                                                    </Button>
                                                </div>
                                            </td>

                                            {/* Render a rotated cell for each variant */}
                                            {haploData.x?.map((value, key) => (
                                                <DynamicRotatedCell
                                                    key={key}
                                                    value={value}
                                                    highlightedSample={highlightedSample}
                                                    clickSample={clickSample}
                                                />
                                            ))}
                                        </tr>



                                    </tbody>
                                </table>

                            </div>
                        </div>

                        {showTips && (
                            <div className="flex flex-col items-center mt-6">
                                <div className="flex justify-center">
                                    <img src={imgSrc} alt="keys" />
                                </div>
                                <p className="mt-4 mb-4 text-sm text-center">
                                    Use command(mac)/control(PC) and the '+' or '-' keys to control zoom of your browser.
                                    <br />
                                    Zoom out until the entire table fits inside your browser window.
                                </p>
                                <hr className="my-4 w-full" />
                                <div className="mb-4 flex items-center justify-center">
                                    Click the red
                                    <i className="far fa-times-circle fa-2x text-red-500 ml-2 mr-2"></i>
                                    to remove a variant from the haploviewer.
                                </div>
                                <hr className="my-4 w-full" />
                                <p>Click variants on the X-axis to sort.</p>
                            </div>
                        )}

                        {showLegend && (
                            <div className="flex flex-wrap -mx-4">
                                <div className="w-1/2 px-4 mt-6">
                                    <label className="block text-gray-700 font-bold mb-2">Types</label>
                                    <ul className="space-y-2">
                                        {[
                                            { color: "bg-blue-500", label: "Reference" },
                                            { color: "bg-red-400", label: "Non-Reference" },
                                            { color: "bg-yellow-300", label: "Heterozygous" },
                                            { color: "bg-white", label: "Missing", symbol: "-" }
                                        ].map((item, idx) => (
                                            <li key={idx} className="flex items-center space-x-2 p-3 bg-gray-100 rounded">
                                                <div className={`w-6 h-6 ${item.color} flex justify-center items-center`}>
                                                    {item.symbol && <span className="ml-2">{item.symbol}</span>}
                                                </div>
                                                <div>{item.label}</div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="w-1/2 px-4 mt-6">
                                    <label className="block text-gray-700 font-bold mb-2">Nucleotide Codes</label>
                                    <ul className="space-y-2">
                                        {[
                                            { color: "bg-yellow-300", label: "A or G", symbol: "R" },
                                            { color: "bg-yellow-300", label: "C or T", symbol: "Y" },
                                            { color: "bg-yellow-300", label: "G or C", symbol: "S" },
                                            { color: "bg-yellow-300", label: "A or T", symbol: "W" },
                                            { color: "bg-yellow-300", label: "G or T", symbol: "K" },
                                            { color: "bg-yellow-300", label: "A or C", symbol: "M" },
                                            { color: "bg-yellow-300", label: "indel heterozygote", symbol: "h" },
                                        ].map((item, idx) => (
                                            <li key={idx} className="flex items-center space-x-2 p-3 bg-gray-100 rounded">
                                                <div className={`w-8 h-8 ${item.color} flex justify-center items-center rounded`}>
                                                    <span>{item.symbol}</span>
                                                </div>
                                                <div>{item.label}</div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        )}
                    </DialogContent>

                    <DialogActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        {/* Left-aligned Go Back button */}
                        <Button
                            variant="contained"
                            color="inherit"
                            startIcon={<ArrowBackIcon />}
                            onClick={handleGoBack}
                        >
                            Go Back
                        </Button>

                        {/* Right-aligned group */}
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => setShowLegend(!showLegend)}
                            >
                                Legend
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => setShowTips(!showTips)}
                            >
                                Tips
                            </Button>
                            <Button
                                variant="contained"
                                color="inherit"
                                onClick={handleClose}
                            >
                                Close
                            </Button>
                        </Box>
                    </DialogActions>


                </Box>
            )}
        </Dialog>
    );
};

export default HaploviewerModal;

// Useful Functions
const transposeArray = (array) => {
    return array[0].map((_, colIndex) => array.map(row => row[colIndex]));
};

function sortWithIndeces(toSort) {
    for (var i = 0; i < toSort.length; i++) {
        toSort[i] = [toSort[i], i];
    }
    toSort.sort(function (left, right) {
        return left[0] < right[0] ? -1 : 1;
    });
    toSort.sortIndices = [];
    for (var j = 0; j < toSort.length; j++) {
        toSort.sortIndices.push(toSort[j][1]);
        toSort[j] = toSort[j][0];
    }
    return toSort;
}

function reorderByIndexes(arr, order) {
    return order.map((index) => arr[index]);
}
